import styled, { keyframes, css } from 'styled-components';
import { FaInstagram, FaFacebookSquare, FaGreaterThan, FaLessThan } from 'react-icons/fa';
import { AiOutlineClose } from 'react-icons/ai';
import { IoMdArrowDropdown, IoMdArrowDropup } from 'react-icons/io';
import { GiHamburgerMenu } from 'react-icons/gi';
const SlideImgCarrossel = keyframes`
    from{
        transform:translateX(100%);
    }
    to{
        transform:translateX(0%);
    }
`;
const AlertInput = keyframes`

    0%{
        border-color:#4b6cb7;
    }50%{
        border-color:#0594a5;
    }100%{
        border-color:#182848;

    }


`;
const TurnTurnHide = keyframes`
    from{
        transform:rotateX(0deg);
        transform:opacity:1;
    }to{
        transform:rotateX(180deg);
        opacity:0;
    }
`;
export const UlNavigation = styled.ul`
    list-style: none;
    display: ${(props) => (props.open ? 'inherit' : 'none')};
`;
export const LiNavigation = styled.li`
    transition: background 0.5s;
    height: 40px;
    border: ${(props) => (props.selected ? '2px solid #0594a5' : 'unset')};
    border-bottom: ${(props) => (props.selected ? '' : '1px solid #c5c5c5')};
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: #f0f2f5;
    text-align: center;
    :hover {
        border: 2px solid #0594a5;
    }
`;
export const DivMain = styled.div`
    height: calc(100% - 60px);
    width: 100%;
    display: flex;
    flex-direction: column;
    background: #fff !important;
    overflow: hidden;
    input {
        transition: background 0.5s;
        :focus {
            animation: ${AlertInput} 0.5s infinite !important;
            background-color: #fff !important;
            border-radius: 6px !important;
        }
    }

    textarea {
        transition: background 0.5s;
        :focus {
            animation: ${AlertInput} 0.5s infinite !important;
            border: 1px solid;
        }
    }
`;
export const DivUlNavigation = styled.div`
    border-right: 1px solid #333;
    height: 100%;
    min-width: 200px;
    max-width: 300px;
    overflow: hidden auto;
    > span {
        min-height: 45px;
        padding: 40px 20px;
        font-size: 20px;
        border-bottom: 1px solid #333;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        text-align: center;
        background: #333;
        font-weight: 600;
        cursor: default;
    }
`;
export const IconFaFacebookSquare = styled(FaFacebookSquare)`
    font-size: 30px;
    margin-right: 16px;
`;
export const IconFaInstagram = styled(FaInstagram)`
    font-size: 30px;
    margin-right: 16px;
`;
export const DivHeaderSocialMidia = styled.div`
    width: 100%;
    padding: 0 0 0 20px;
    cursor: pointer;
    display: flex;
    @media (max-width: 800px) {
        display: none;
    }
`;

export const ImgLogoHeader = styled.img`
    max-height: 175px;
    margin: 20px;
    cursor: pointer;
    @media (max-width: 800px) {
        max-height: 150px;
        max-width: 100%;
    }
`;

export const ImgCarrossel = styled.img`
    height: 550px;
    width: 100%;
    @media (max-width: 800px) {
        height: unset;
    }
    /* animation:${SlideImgCarrossel} 1s forwards; */
`;
export const TitleFooter = styled.h5`
    font-size: 18px;
`;
export const PFooter = styled.div`
    display: flex;
    align-items: center;
    font-size: 15px;
    margin: 10px 0;
`;
export const IconAiOutlineClose = styled(AiOutlineClose)`
    font-size: 30px;
    cursor: pointer;
    transition: 0.5s;
    :hover {
        transform: scale(1.08);
    }
`;
export const DivInputFile = styled.div`
    position: absolute;
    bottom: 0;
    > div {
        > button {
        }
    }
`;
export const IconFaGreaterThan = styled(FaGreaterThan)`
    font-size: 30px;
    position: absolute;
    top: 50%;
    right: 5%;
    cursor: pointer;
    color: #989898;
    transition: 0.5s;
    :hover {
        color: #fff;
        transform: scale(1.2);
    }
`;
export const IconFaLessThan = styled(FaLessThan)`
    font-size: 30px;
    position: absolute;
    top: 50%;
    left: 5%;
    cursor: pointer;
    color: #989898;
    transition: 0.5s;
    :hover {
        color: #fff;
        transform: scale(1.2);
    }
`;
export const LiChangeImageLogo = styled.li`
    transition: background 0.5s;
    height: 40px;
    border-bottom: 1px solid #c5c5c5;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: #f0f2f5;
    text-align: center;
    :hover {
        border: 2px solid #0594a5;
    }
    > div {
        margin: 0 !important;
        height: unset !important;

        > button {
            background-color: #f0f2f5 !important;
            border: 0px;
            > span {
                font-size: 14px !important;
                color: inherit;
            }
        }
    }
`;
export const DivItemCarrossel = styled.div`
    position: relative;
    display: ${(props) => (props.active ? 'flex' : 'none')};
    align-items: center;
    justify-content: center;
    text-align: center;
`;
export const DivCaption = styled.div`
    display: flex;
    flex-direction: column;
    position: absolute;
    max-width: 610px;
    background: rgba(255, 255, 255, 0.5);
    color: #000;
    padding: 20px;
    h5 {
        font-size: 1.25rem;
    }
    p {
        font-size: 1rem;
    }
`;
export const TextareaSlider = styled.textarea`
    font-size: 16px;
    padding: 10px 5px;
    resize: none;
`;
export const DivTitle = styled.div`
    margin: 12px auto;
    height: 40px;
    font-size: 32px;
    @media (max-width: 800px) {
        display: flex;
        width: 100%;
        height: 40px;
        justify-content: flex-start;
        align-items: center;
        position: relative;
    }
`;
export const DivBody = styled.div`
    display: flex;
    height: calc(100% - 64px);
    border-top: 1px solid #333;
`;
const Hover = css`
    :hover {
        background: rgba(0, 0, 0, 0.6);
        cursor: pointer;
        div {
            img {
                opacity: 0.1;
            }
        }
        span {
            display: block;
            position: absolute;
            font-size: 40px;
            color: #fff;
            user-select: none;
        }
    }
`;
export const DivHeaderMain = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 0 0 0;
    width: 100vw;
    span {
        display: none;
    }
    /* :active{
        animation:${TurnTurnHide} .3s forwards;
    } */
    ${(props) => (props.verifyAnyPopupOpen ? '' : Hover)}
`;
export const DivMenu = styled.div`
    margin: 0 0 20px 0;
    > ul {
        list-style: none;
        display: flex;
        align-items: center;
        cursor: default;
        li {
            display: flex;
            align-items: center;
            margin: 0 10px;
            @media (max-width: 800px) {
                margin: 0 5px;
            }
            svg {
                display: flex;
                align-self: flex-end;
                cursor: pointer;
            }
        }
    }
    @media (max-width: 800px) {
        font-size: 10px;
    }
`;
const HoverPageAboutMe = css`
    :hover {
        background: rgba(0, 0, 0, 0.6);
        cursor: pointer;
        > span {
            display: block;
            position: absolute;
            color: #fff;
            font-size: 40px;
            user-select: none;
        }
        > img {
            opacity: 0.3;
        }
    }
`;

export const DivMainAboutMe = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: center;
    justify-self: center;
    margin: auto;
    min-height: 200px;
    margin: 20px auto;
    max-width: 1140px;
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    > span {
        display: none;
    }
    ${({ verifyAnyPopupOpen }) => (verifyAnyPopupOpen ? '' : HoverPageAboutMe)}
`;
export const DivBodyPage = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    align-self: center;
    justify-self: center;
    min-height: 200px;
    margin: 20px auto;
    max-width: 1140px;
    display: flex;
    flex-direction: column;
    width: 100%;
    > div {
        @media (max-width: 800px) {
            font-size: 16px !important;
            margin: 10px auto 0 auto;
        }
    }
    > h1 {
        @media (max-width: 800px) {
            margin: 0 0 0 10px;
            font-size: 18px;
        }
    }
    @media (max-width: 800px) {
        margin: 20px auto 0 auto;
    }
`;
export const DivTextContent = styled.div`
    resize: none;
    font-size: 20px;
    padding: 10px;
    margin: 20px 0 0 0;
    white-space: break-spaces;
`;
export const IconIoMdArrowDropup = styled(IoMdArrowDropup)`
    font-size: 30px;
`;
export const IconIoMdArrowDropdown = styled(IoMdArrowDropdown)`
    font-size: 30px;
`;
export const UlMenuTop = styled.ul`
    list-style: none;
    display: flex;
    user-select: none;
    align-items: center;
    @media (max-width: 800px) {
        display: ${(props) => (props.showDisplay ? 'flex' : 'none')};
        position: absolute;
        top: 40px;
        flex-direction: column;
        align-items: flex-start;
        background: #fefefe;
        z-index: 5;
        height: calc(100vh - 100px) !important;
        overflow: hidden;
        > li {
            margin: 8px 10px;
        }
        > span {
            display: none;
        }
    }
`;
export const LiMenuTop = styled.li`
    margin: 0 10px;
    font-size: 18px;
    padding: 8px 8px 2px 8px;
    cursor: pointer;
    transition: 0.5s;
    font-weight: 900;
    /* border-radius:6px; */
    border-bottom: 1px solid ${(props) => (props.selected ? '#0594a5' : '#fff')};

    :hover {
        transform: scale(1.08);
    }
`;
export const LiOpcoesMenuTop = styled.li`
    display: ${(props) => (props.completed ? 'flex' : 'none')};
    justify-content: center;
    align-items: center;
    font-size: 16px;
    cursor: pointer;
    background-color: #0594a5;
    border-radius: 6px;
    font-weight: 600;
    padding: 8px 8px 8px 8px;
    color: #eeeeee;
    @media (max-width: 800px) {
        display: none;
    }
`;
export const DivNextButton = styled.div`
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70px;

    font-size: 16px;
    background: #0594a5;
    font-weight: 600;
`;
export const DivPreviewSite = styled.div`
    overflow: hidden auto;
    width: 100%;
    padding: 0;
    background: #f3f3f3;
`;
export const DivMainFirstPage = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > span {
        display: none;
    }

    :hover {
        background: ${(props) => (props.verifyAnyPopupOpen ? '' : 'rgba(0,0,0,0.6)')};
        cursor: ${(props) => (props.verifyAnyPopupOpen ? '' : 'pointer')};
        div {
            img {
                opacity: ${(props) => (props.verifyAnyPopupOpen ? '' : '0.1')};
            }
        }
        > span {
            display: ${(props) => (props.verifyAnyPopupOpen ? '' : 'flex')};
            justify-self: ${(props) => (props.verifyAnyPopupOpen ? '' : 'center')};
            position: ${(props) => (props.verifyAnyPopupOpen ? '' : 'absolute')};
            font-size: ${(props) => (props.verifyAnyPopupOpen ? '' : '40px')};
            color: ${(props) => (props.verifyAnyPopupOpen ? '' : '#fff')};
            cursor: ${(props) => (props.verifyAnyPopupOpen ? '' : 'pointer')};
            user-select: ${(props) => (props.verifyAnyPopupOpen ? '' : 'none')};
        }
    }
`;
const HoverFooter = css`
    :hover {
        background: rgba(0, 0, 0, 0.6);
        cursor: pointer;
        > span {
            :last-child {
                display: block;
                position: absolute;
                font-size: 40px;
                color: #fff;
                user-select: none;
            }
        }
    }
`;
export const DivMainFooter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0 0 0;
    padding: 0 0 20px 0;
    position: relative;
    > span {
        display: none;
    }
    ${(props) => (props.verifyAnyPopupOpen ? '' : HoverFooter)}

    @media(max-width:800px) {
        flex-direction: column;
        align-items: flex-start;
    }
    h5 {
        @media (max-width: 800px) {
            font-size: 14px;
        }
    }
    div {
        @media (max-width: 800px) {
            font-size: 12px;
        }
    }
    button {
        span {
            @media (max-width: 800px) {
                font-size: 12px !important;
            }
        }
    }
`;

export const DivFooterContent = styled.div`
    margin: 0 20px 0 0;
    max-width: 350px;
    @media (max-width: 800px) {
        margin: 16px 0 16px 8px;
    }
`;

const HoverSecondPage = css`
    :hover {
        background: rgba(0, 0, 0, 0.6);
        cursor: pointer;
        > span {
            display: block;
            position: absolute;
            color: #fff;
            font-size: 40px;
            user-select: none;
        }
        > img {
            opacity: 0.3;
        }
    }
`;
export const DivMainSecondPage = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    > span {
        display: none;
    }
    ${({ verifyAnyPopupOpen }) => (verifyAnyPopupOpen ? '' : HoverSecondPage)}
`;
export const ImgPageContent = styled.img`
    width: 100%;
    height: 550px;
    @media (max-width: 800px) {
        max-width: 100%;
        height: unset;
    }
`;
export const IconGiHamburgerMenu = styled(GiHamburgerMenu)`
    font-size: 30px;
    margin: 0 15px;
    @media (min-width: 800px) {
        display: none;
    }
`;
export const DivTextAreaTour = styled.div`
    max-width: 100%;
    height: 240px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    @media (max-width: 500px) {
        height: 310px;
    }
`;
export const TextAreaTour = styled.textarea`
    padding: 10px;
    font-size: 18px;
    margin: 10px 0 0 10px;
    box-sizing: border-box;
    width: 100%;
    height: calc(100% - 100px);
`;
export const ImgCoverProfile = styled.img`
    width: 100%;
    height: 400px;
    @media (max-width: 800px) {
        height: unset;
    }
`;
export const DivProfileContent = styled.div`
    display: flex;
    margin: 20px auto;
    max-width: 1140px;
    align-items: flex-start;
    width: 100%;
    > img {
        max-width: 250px;
        margin: 0 15px;
        display: flex;
        align-self: start;
        @media (max-width: 800px) {
            max-width: 150px;
        }
    }
    @media (max-width: 800px) {
        flex-direction: column;
    }
`;

export const DivTextProfile = styled.div`
    > h1 {
        @media (max-width: 800px) {
            font-size: 18px;
            margin: 12px 0 0 8px;
        }
    }
    > div {
        resize: none;
        font-size: 20px;
        padding: 10px;
        margin: 20px 0 0 0;
        @media (max-width: 800px) {
            font-size: 16px;
        }
    }
`;
